import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Fragment } from 'react';
import { deserialize } from '../utils/slate2markdown';
import OutlineView from '../components/outline';
import LoadScript from '../components/load-script';
import SlateViewer from './slate-viewer';
import '../assets/css/markdown-viewer.css';
var URL = require('url-parse');
var MarkdownViewer = /*#__PURE__*/function (_React$Component) {
  _inherits(MarkdownViewer, _React$Component);
  var _super = _createSuper(MarkdownViewer);
  function MarkdownViewer(props) {
    var _this;
    _classCallCheck(this, MarkdownViewer);
    _this = _super.call(this, props);
    _this.scrollToNode = function (node) {
      var url = new URL(window.location.href);
      url.set('hash', 'user-content-' + node.children[0].text);
      window.location.href = url.toString();
    };
    _this.getTitlesInfo = function () {
      var titlesInfo = [];
      var headingList = document.querySelectorAll('h2[id^="user-content"], h3[id^="user-content"]');
      for (var i = 0; i < headingList.length; i++) {
        titlesInfo.push(headingList[i].offsetTop);
      }
      _this.titlesInfo = titlesInfo;
    };
    _this.deserializeValue = function (markdownContent) {
      var nodes = deserialize(markdownContent);
      if (_this.props.modifyValueBeforeRender) {
        nodes = _this.props.modifyValueBeforeRender(nodes);
      }
      _this.setState({
        value: nodes
      });
    };
    _this.titlesInfo = [];
    _this.state = {
      value: null
    };
    return _this;
  }
  _createClass(MarkdownViewer, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.deserializeValue(this.props.markdownContent);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.showTOC) {
        this.getTitlesInfo();
      }
      if (this.props.onContentRendered) {
        this.props.onContentRendered(this);
      }
      window.markdownViewer = this;
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.markdownContent !== nextProps.markdownContent) {
        this.deserializeValue(nextProps.markdownContent);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.markdownViewer = null;
    }
  }, {
    key: "render",
    value: function render() {
      var value = this.state.value;
      if (!value) return null;
      var _this$props = this.props,
        scriptSource = _this$props.scriptSource,
        showTOC = _this$props.showTOC,
        activeTitleIndex = _this$props.activeTitleIndex,
        updateForNoOutline = _this$props.updateForNoOutline;
      if (scriptSource) {
        return /*#__PURE__*/React.createElement(LoadScript, {
          scriptSource: this.props.scriptSource
        }, /*#__PURE__*/React.createElement(SlateViewer, {
          value: value
        }), showTOC && /*#__PURE__*/React.createElement("div", {
          className: "seafile-markdown-outline"
        }, /*#__PURE__*/React.createElement(OutlineView, {
          document: value,
          isViewer: true,
          activeTitleIndex: activeTitleIndex,
          scrollToNode: this.scrollToNode,
          updateForNoOutline: updateForNoOutline
        })));
      }
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(SlateViewer, {
        value: value
      }), showTOC && /*#__PURE__*/React.createElement("div", {
        className: "seafile-markdown-outline"
      }, /*#__PURE__*/React.createElement(OutlineView, {
        document: value,
        isViewer: true,
        activeTitleIndex: activeTitleIndex,
        scrollToNode: this.scrollToNode
      })));
    }
  }]);
  return MarkdownViewer;
}(React.Component);
var defaultProps = {
  activeTitleIndex: 0,
  markdownContent: '',
  showTOC: true,
  isShared: false
};
MarkdownViewer.defaultProps = defaultProps;
export default MarkdownViewer;